import { Button } from '@folio/components';
import { cn } from '@folio/lib';
import { Loader2Icon, XCircleIcon } from 'lucide-react';
import { type ReactNode, Suspense, useCallback } from 'react';
import { ErrorBoundary, type FallbackProps, getErrorMessage } from 'react-error-boundary';
import { Center, Stack } from '@folio/components/ui/flex';

export type SuspenseLoaderProps = {
  className?: string;
  children: ReactNode;
};

export function SuspenseLoader({ className, children }: SuspenseLoaderProps) {
  const fallbackRender = useCallback(
    ({ error, resetErrorBoundary }: FallbackProps) => (
      <Stack
        gap={0}
        className={cn('top-0 left-0 bottom-0 right-0 py-32 items-center justify-center', className)}
      >
        <XCircleIcon className="w-8 h-8 mb-2" />
        <div className="mb-6">{getErrorMessage(error)}</div>
        <Button onClick={resetErrorBoundary}>Réessayer</Button>
      </Stack>
    ),
    [className],
  );

  return (
    <ErrorBoundary fallbackRender={fallbackRender}>
      <Suspense
        fallback={
          <Center className={cn('top-0 left-0 bottom-0 right-0 py-32', className)}>
            <Loader2Icon className="w-8 h-8 animate-spin" />
          </Center>
        }
      >
        {children}
      </Suspense>
    </ErrorBoundary>
  );
}
